import HelpModal from './HelpModal.view';

export default HelpModal;
